<template>
  <div>
    <v-card>
      <v-card-title
        class="headline font-weight-medium pb-0"
        primary-title
      >
        Add Kiosk
      </v-card-title>

      <v-card-text>
        <v-layout
          column
          wrap
          align-center
        >
          <v-form ref="addKioskForm">
            <v-input
              v-model="code"
              style="max-width: 300px;"
              hint="Enter the code shown in kiosk"
              persistent-hint
              :rules="[v=> !!v || 'passcode is required' , v=> !!v && v.length === 6 || 'passcode should have all the digits']"
              autofocus
            >
              <template
                v-if="show"
                slot="default"
              >
                <template
                  v-for="n in 6"
                >
                  <v-text-field
                    :id="`field_${n}`"
                    :key="n"
                    class="codeFields"
                    justify-center
                    :class="textFieldPadding(n)"
                    style="font-size:24px"
                    :autofocus="n === 1"
                    mask="N"
                    hide-details
                    @input="combineCodes(n, $event)"
                    @keyup.delete="removeCode(n)"
                  />
                </template>
              </template>
            </v-input>
          </v-form>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          flat
          :disabled="loading"
          @click="cancelKiosk"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          flat
          :loading="loading"
          @click="addKiosk"
        >
          add
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { functions } from '@/firebase';
export default {
  name: 'AddKiosk',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      code: [],
      error: false,
      errorMessages: [],
      loading: false
    };
  },
  methods: {
    textFieldPadding(n) {
      if (n === 1) return 'pr-2';
      return n <= 5 ? 'px-2' : 'pl-2';
    },
    combineCodes(n, value) {
      if (!value) return;
      if (n < 6) document.getElementById(`field_${n + 1}`).focus();
      this.code.splice(n + 1, 1, value);
    },
    removeCode(n) {
      if (n > 1) document.getElementById(`field_${n - 1}`).focus();
      this.code.splice(n - 1, 1);
    },
    cancelKiosk() {
      this.$emit('closeDialog');
      this.$refs.addKioskForm.reset();
    },
    addKiosk() {
      if (!this.$refs.addKioskForm.validate()) return;
      this.loading = true;
      this.$emit('persistDialog');
      const addKioskFunc = functions.httpsCallable('vms-kiosks-pairKiosk');
      let passcode = '';
      this.code.forEach(digit => {
        passcode = passcode + digit;
      });
      const data = {
        lid: this.$store.state.VMS.lid,
        location: 'Towers Max',
        passcode: passcode
      };
      addKioskFunc(data)
        .then(() => {
          this.loading = false;
          this.$emit('closeDialog');
          this.$emit('success', 'Kiosk has been added successfully');
          this.$refs.addKioskForm.reset();
        })
        .catch(err => {
          this.loading = false;
          this.$refs.addKioskForm.reset();
          this.$emit('error', err);
          this.$emit('closeDialog');
        });
    }
  }
};
</script>